import { ObservationImagesViewModel } from "../inspections/inspection.model";
import { GenericIdName } from "../setup-implement/setup-implement.model";

export class AddObservationPointModal {
  public ImplementInspectionId: number
  public Name: string
  public ComponentID: number
  public OPId: number
  public ObservationList: number[]
  public OPTypeId: number
  public NoOfReadings: number
  public LimitsNew: number
  public LimitsScrap: number
  public QuestionImage: string
  public Comment: number
  public Image: number
  public positionX: number
  public positionY: number
  public EndpositionX: number
  public EndpositionY: number
  public schematicId: number
  public Qname: string;
  public Qdesc: string;
  public LimitRange: number;
  public Measurement: number
  public isCrackFixed: boolean;
  public CreateDate: Date
  public InspectionTypeID: number
  public ImplementID: number
  public IsAnswer: boolean;
  public IsImage: boolean;
  public Comments: string;
  public Images: ObservationImagesViewModel[];
  public ObsLocationId: number;
  public CrackSeverityId: number;
  public CrackLocationId: number;
  public StringInspectionDate: string;
  public CrackStatusId?: number;
}


export class UpdateObservationPointModal {
  public Name: string
  public ComponentID: number
  public ObservationList: number[]
  public ObservationListId: number
  public OPTypeId: number
  public NoOfReadings: number
  public LimitsNew: number
  public LimitsScrap: number
  public ID: number
  public ComponentId: number
  public isApplytoAll: boolean
  public IsActive: boolean
  public ImplementId: number
  public QName: string;
  public QDesc: string;
  public LimitRange: number;
  public Measurement: number
  public InspectionTypeID: number
  public IsAnswer: boolean;
  public IsImage: boolean;
  public Xcoord: number;
  public Ycoord: number;
  public EndXcoord: number;
  public EndYcoord: number;

}

export class RebuildImplementVM {
  public ImplementId: number;
  public Status: number;
  public WorkshopId: number
  public RebuilStartDate: Date;
  public cost: number;
  public comment: string;
  public jobsiteID: number;
}
export class ImplementCycleDetails {
  public ImplementId: number;
  public StartDate: Date;
  public CycleNo: number;
  public Hours: number;
  public BCM: number;
  public Tons: number;
  public EndDate: Date;
  public Id: number;
  public Cost: number;
}

export class ImplementRebuildCompleteVM {
  public ImplementId: number;
  public StartDate: Date;
  public CycleNo: number;
  public Hours: number;
  public BCM: number;
  public Tons: number;
  public EndDate: Date;
  public jobsiteID: number;
  public comment: string;
}

export class UpdateImplementTargets {
  public ImplementId: number;
  public CycleNo: number;
  public Hours: number;
  public BCM: number;
  public Tons: number;
  public NewHours: number;
  public NewBCM: number;
  public NewTons: number;
  public CycleId: number;
}
